<div class="h-full w-full">
    @if (chartId) {
        <canvas [id]="chartId" baseChart class="charts" width="400">
            <!-- {{ chart }} -->
        </canvas>
    }
</div>